export const MEDIA = {
  SM: "(max-width:750px)",
  MD: "(max-width:1000px)",
  XS: "(max-width:450px)",
};
